<kendo-dialog-titlebar>
    {{'admin-center.header.selectEmployee' | translate}}
</kendo-dialog-titlebar>

<div  fxLayout="column" fxLayoutGap="15px">

    <form [formGroup]="form">

            <app-employee-select-ctrl [caption]="caption" [settings]="{fxFill:true}"
            [formControlName]="'selectedEmployeeId'"></app-employee-select-ctrl>

    </form>
    
    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
        <button type="button" kendoButton (click)="confirm()" [primary]="true">
            <span>{{'global.confirm' | translate}}</span>
        </button>
    </div>
</div>